<app-list-chips-active-filters [component]="filters()" />

<ng-container *ngIf="config().summaryComponent">
  <ng-container *ngComponentOutlet="config().summaryComponent"></ng-container>
</ng-container>

<list-header
  *ngIf="service?.config?.listTitle && !headerHidden()"
  [headerTemplate]="headerTemplate()"
  [title]="service?.config?.listTitle"
/>

<div class="datatable-container" #listContainer [ngClass]="{ 'header-hidden': headerHidden() }">
  <div
    *ngIf="service?.config?.showColumnsSettings !== false"
    class="datatable-filters"
    [matMenuTriggerFor]="showColumnsMenu"
  >
    <mat-icon>more_vert</mat-icon>
  </div>
  <list-loader />
  <list-empty-states [emptyTemplate]="emptyTemplate()" />
  <ngx-datatable
    #table
    [rows]="service.rows"
    [limit]="service?.config?.limit"
    [columns]="service?.config?.columns"
    [columnMode]="service?.config?.columnMode"
    [offset]="service.config?.offset"
    [rowHeight]="service.config?.rowHeight ? service.config?.rowHeight : 60"
    [headerHeight]="40"
    [footerHeight]="40"
    [sortType]="service.config?.sortType"
    [scrollbarV]="true"
    [scrollbarH]="true"
    [trackByProp]="service?.config?.trackByProp"
    [virtualization]="service?.config?.virtualization"
    [externalPaging]="true"
    [externalSorting]="true"
    [messages]="{ emptyMessage: '' }"
    [selected]="selected()"
    [selectionType]="service.config?.selectionType"
    [reorderable]="false"
    [swapColumns]="false"
    [rowClass]="config().getRowClass"
    (sort)="onSort($event)"
    (select)="select.emit($event)"
    (activate)="onActivate($event)"
    (treeAction)="onTreeAction($event)"
    [selectCheck]="singleSelectCheck.bind(this)"
    [treeFromRelation]="service.config?.treeAction?.treeFromRelation"
    [treeToRelation]="service.config?.treeAction?.treeToRelation"
  >
    <ngx-datatable-footer>
      <ng-template ngx-datatable-footer-template>
        <app-list-footer class="w-100" />
      </ng-template>
    </ngx-datatable-footer>
  </ngx-datatable>

  <ng-template
    let-column="column"
    let-row="row"
    #checkbox
    ngx-datatable-cell-template
    let-rowIndex="rowIndex"
  >
    <list-checkbox [row]="row" />
  </ng-template>

  <ng-template
    let-column="column"
    let-row="row"
    #checkboxAll
    ngx-datatable-header-template
    let-rowIndex="rowIndex"
  >
    <list-checkbox [row]="row" />
  </ng-template>

  <ng-template
    let-column="column"
    let-row="row"
    #toggleMenu
    ngx-datatable-cell-template
    let-rowIndex="rowIndex"
  >
    <app-list-toggle-menu
      class="d-block"
      [component]="column?.component"
      [row]="row"
      [showToggleMenu]="showToggleMenu()"
    />
  </ng-template>

  <ng-template let-cellContext="cellContext" #toggleTree ngx-datatable-tree-toggle>
    <list-tree-action [row]="cellContext" [treeDisabled]="treeDisabled.bind(this)" />
  </ng-template>
</div>

<mat-menu #showColumnsMenu="matMenu" xPosition="after" class="menu-v2">
  <ng-container
    *ngFor="
      let column of service.config.columns.concat(service.config.hideColumns).sort(columnsSort);
      trackBy: identify
    "
  >
    <div
      class="form-control-checkbox d-block mb-2 mt-2"
      *ngIf="!column.toggleMenu && !column.hideNotShow"
      (click)="$event.stopPropagation()"
      [ngClass]="{ 'form-control-checkbox--disabled': column.canNotShow === false }"
    >
      <label class="m-0 d-flex align-items-center">
        <input
          type="checkbox"
          [checked]="!column.notShow"
          (change)="onColumnShowChange(column)"
          [disabled]="column.canNotShow === false"
        />
        <span></span>
        <span [innerHTML]="column.name"></span>
      </label>
    </div>
  </ng-container>
</mat-menu>
